<br>
<div class="text-wrapper">
<span *ngIf="item.source_description_rus; else descriptionEnglish"> {{item.source_description_rus}}</span>
<ng-template #descriptionEnglish><span>{{item.source_description}}</span></ng-template>
</div>
